import { ChangeDetectionStrategy, Component, computed, input, viewChild } from '@angular/core';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

interface Item<T> {
  value: T;
  label: string;
  key: string;
}

@Component({
  selector: 'lcm-autocomplete',
  exportAs: 'lcmAutocomplete',
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [MatAutocompleteModule, MatInputModule, MatFormFieldModule],
  template: `
    <mat-autocomplete autoActiveFirstOption requireSelection>
      @for (item of filteredItems(); track item.value) {
        <mat-option [value]="item.value">{{ item.label }}</mat-option>
      }
    </mat-autocomplete>
  `,
})
export class Autocomplete<T> {
  autocomplete = viewChild.required(MatAutocomplete);

  options = input.required<(Item<T> | string)[]>();
  pattern = input.required<string>();

  items = computed(() =>
    this.options().map((opt) =>
      typeof opt === 'string' ? { value: opt, label: opt, key: String(opt).toLowerCase() } : opt,
    ),
  );

  filteredItems = computed(() => {
    const items = this.items();

    const pat = this.pattern()?.toLowerCase() || '';

    return items.filter(({ key }) => key.includes(pat));
  });
}
